module.exports = new __parcel__URL__("step_five_vector_light_optimal.1d639656.png").toString();